// src/components/ambassadors/FloatingParticles.tsx
export function FloatingParticles() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {Array.from({ length: 18 }).map((_, i) => (
        <span
          key={i}
          className="absolute w-1 h-1 rounded-full bg-white/10 animate-pulse"
          style={{
            left: `${(i * 17) % 100}%`,
            top: `${(i * 13) % 100}%`,
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </div>
  );
}
